import { ScanResult } from "@capacitor-mlkit/barcode-scanning";

import { logger } from "../../helpers/debug";

const log = logger.extend("NativeQrCodeScanner");

export async function installNativeScanner(): Promise<boolean> {
  const { BarcodeScanner, GoogleBarcodeScannerModuleInstallState } = await import("@capacitor-mlkit/barcode-scanning");

  const { available } = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
  if (!available) {
    // install barcode scanner
    await BarcodeScanner.installGoogleBarcodeScannerModule();
    await new Promise<void>((res, rej) => {
      let sub: Awaited<ReturnType<typeof BarcodeScanner.addListener>> | undefined;

      BarcodeScanner.addListener("googleBarcodeScannerModuleInstallProgress", (event) => {
        log("Installing google barcode scanner", event.progress);
        switch (event.state) {
          case GoogleBarcodeScannerModuleInstallState.COMPLETED:
            sub?.remove();
            res();
            break;
          case GoogleBarcodeScannerModuleInstallState.PENDING:
            log("Pending download");
            break;
          case GoogleBarcodeScannerModuleInstallState.DOWNLOADING:
            log("Downloading");
            break;
          case GoogleBarcodeScannerModuleInstallState.DOWNLOAD_PAUSED:
            log("Download paused");
            break;
          case GoogleBarcodeScannerModuleInstallState.INSTALLING:
            log("Installing");
            break;
          case GoogleBarcodeScannerModuleInstallState.FAILED:
            sub?.remove();
            rej(new Error("Failed to install"));
            break;
          case GoogleBarcodeScannerModuleInstallState.CANCELED:
            sub?.remove();
            rej(new Error("Canceled install"));
            break;
        }
      }).then((handle) => {
        sub = handle;
      });
    });
  }

  const { supported } = await BarcodeScanner.isSupported();
  if (!supported) throw new Error("Unsupported");
  const { camera } = await BarcodeScanner.requestPermissions();
  const granted = camera === "granted" || camera === "limited";
  if (!granted) throw new Error("Camera access denied");

  return true;
}

export async function scanSingle(): Promise<ScanResult> {
  const { BarcodeScanner } = await import("@capacitor-mlkit/barcode-scanning");
  return await BarcodeScanner.scan();
}
